// Suppresses a field's error until the user has either entered something
// invalid (format errors surface immediately on blur) or attempted to
// submit the form (at which point "required" errors on empty fields also
// surface). Prevents an empty-but-untouched-by-submit field from turning
// red just because the user tabbed through it.
export const getFieldError = (
  touched: boolean | undefined,
  value: string | null | undefined,
  error: string | undefined,
  submitCount: number,
): string | undefined => {
  if (!touched || !error) return undefined;
  if (!value?.trim() && submitCount === 0) return undefined;
  return error;
};
